import React, { useEffect, useState } from "react"
import styles from "./Welcome.module.scss"
import { ChatModeInterface } from "../../../Home/Home"
import logo from "../logo-square.png"

const Welcome: React.FC<{
    sendMessage: any
    chatMode: ChatModeInterface["chatMode"]
    setChatMode: any
}> = ({ sendMessage, chatMode, setChatMode }) => {
    const [queueMessage, setQueueMessage] = useState<string>("")

    useEffect(() => {
        if (!queueMessage) return
        sendMessage(queueMessage)
        setQueueMessage("")
    }, [chatMode, queueMessage])

    return (
        <div className={styles.Welcome}>
            <div className={styles.logo}>
                <img src={logo} alt="Pretzel Logo" />
                <h1>Pretzel</h1>
            </div>
            <p>
                Ask Pretzel anything, query your{" "}
                <span onClick={() => sendMessage("files")}>files</span>, or search the web.
                <br />
                {"Web Search "}
                <span
                    onClick={() => {
                        setChatMode("web search only")
                        setQueueMessage("french revolution")
                    }}>
                    on French Revolution
                </span>
                {". Ask my files on "}
                <span
                    onClick={() => {
                        setChatMode("asking all files")
                        setQueueMessage("External Hard Drive in sales")
                    }}>
                    sales data
                </span>
                {". Ask the web about "}
                <span
                    onClick={() => {
                        setChatMode("asking the web")
                        setQueueMessage("latest advancements in quantum computing as of July 2025")
                    }}>
                    latest advancements in quantum computing
                </span>
            </p>
        </div>
    )
}

export default Welcome
